































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { GlobalHelper } from "@/helper/global-helper";
import { ErrorBag, Validator } from "vee-validate";
import { PageStore, PageStores } from "@/store/modules/page-store";
import Spinner from "@/components/Spinner.vue";
import VorfallmanagementApi from "../api/api-vfmt";
import Vorfallmanagement from "../api/Vorfallmanagement";
import VorfallmanagementDefaultDaten from "../api/Default-Daten-vfmt";

@Component({
  components: {
    Spinner,
  },
})
export default class EinstellungenLeitlinienVfmt extends Vue {
  public errors!: ErrorBag;
  public $validator!: Validator;
  public loading: boolean = false;
  public sending: boolean = false;
  public hadError: boolean = false;

  public vfmtApi: VorfallmanagementApi = new VorfallmanagementApi();

  public leitlinien: Vorfallmanagement.Leitlinie[] = [];
  public currentLeitlinie: Vorfallmanagement.Leitlinie =
    VorfallmanagementDefaultDaten.Leitlinie();

  @Watch("leitlinien", { deep: true, immediate: true })
  updateCurrentLeitlinie() {
    if (this.leitlinien.length) {
      const temp = [...this.leitlinien].reverse();
      this.currentLeitlinie = temp[0];
    } else {
      this.currentLeitlinie = VorfallmanagementDefaultDaten.Leitlinie();
    }
  }

  async mounted() {
    await this.loadData();
  }

  async loadData() {
    try {
      this.loading = true;
      this.leitlinien = await this.vfmtApi.GetLeitlinien();
    } catch (error) {
      this.errors.add(error as any);
      return null;
    } finally {
      this.loading = false;
    }
  }

  async onSubmit(event: any) {
    try {
      this.sending = true;
      await this.$validator.validateAll();
      if (this.errors.count() == 0) {
        if (this.currentLeitlinie.Id == 0) {
          await this.vfmtApi.AddLeitlinie(this.currentLeitlinie);
        } else {
          await this.vfmtApi.UpdateLeitlinie(this.currentLeitlinie);
        }

        GlobalHelper.NotifySuccess();
      }
    } catch (e) {
      console.log(e);
    } finally {
      this.sending = false;
      await this.loadData();
    }
  }
}
